import { render, staticRenderFns } from "./webinar_information.vue?vue&type=template&id=12428ed4"
import script from "./webinar_information.vue?vue&type=script&lang=js"
export * from "./webinar_information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports